import { CheckoutStateEnum } from '@monofront/types';

export const CHECKOUT_STATE_INDEXES = {
  [CheckoutStateEnum.CART]: 0,
  [CheckoutStateEnum.ADDRESSED]: 1,
  [CheckoutStateEnum.SHIPPING_SELECTED]: 2,
  [CheckoutStateEnum.SHIPPING_SKIPPED]: 2,
  [CheckoutStateEnum.PAYMENT_SELECTED]: 3,
  [CheckoutStateEnum.PAYMENT_SKIPPED]: 3,
  [CheckoutStateEnum.COMPLETED]: 4,
};

export const daysOfWeek = {
  1: 'Lundi',
  2: 'Mardi',
  3: 'Mercredi',
  4: 'Jeudi',
  5: 'Vendredi',
  6: 'Samedi',
  7: 'Dimanche',
};

export const COUNTRY_BY_CODE = {
  FR: 'France',
};

export const CHECKOUT_ERRORS = {
  STOCK_IS_INSUFFICIENT: 'STOCK_IS_INSUFFICIENT',
  PRODUCT_VARIANT_NOT_EXIST: 'PRODUCT_VARIANT_NOT_EXIST',
  PRODUCT_NOT_EXIST: 'PRODUCT_NOT_EXIST',
};

export const CHECKOUT_TRACKING_STEPS = {
  DELIVERY: 1,
  PAYMENT: 2,
};

export const SHOW_MORE_PICKUPS_STEP_SIZE = 10;
